/**
 * Video stories: custom play button over Shopify-hosted videos.
 * Uses event delegation so it keeps working after Flickity moves the slides
 * and after the theme editor reloads the section.
 */
if (!window.__videoStoriesInit) {
  window.__videoStoriesInit = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-video-stories-play]');
    if (!button) {
      return;
    }
    var media = button.closest('.video-story__media');
    var video = media && media.querySelector('video');
    if (!video) {
      return;
    }
    video.controls = true;
    video.play();
  });

  // "play", "pause" and "ended" do not bubble, so listen in the capture phase.
  document.addEventListener(
    'play',
    function (event) {
      var video = event.target;
      if (!(video instanceof HTMLVideoElement)) {
        return;
      }
      var media = video.closest('.video-story__media');
      if (!media) {
        return;
      }
      media.classList.add('is-playing');
      document.querySelectorAll('.video-story__media video').forEach(function (other) {
        if (other !== video) {
          other.pause();
        }
      });
    },
    true
  );

  document.addEventListener(
    'ended',
    function (event) {
      var video = event.target;
      if (!(video instanceof HTMLVideoElement)) {
        return;
      }
      var media = video.closest('.video-story__media');
      if (!media) {
        return;
      }
      media.classList.remove('is-playing');
      video.controls = false;
    },
    true
  );
}
